import React from 'react';
import { Button, Message, Separator, Items } from 'common/components';
import { Glossary, BoardGL } from 'common/utils/glossary';

interface SelectCountryBoardProps {
  /** SelectCountryBoardの表示有無 */
  isDisplay: boolean;
  /** グロッサリ */
  glossary: Glossary;
  /** クローズボタンをクリックした際の処理 */
  onClickClose: () => void;
  /** 地域のリスト */
  regions: {
    id: string;
    text: string;
    select: true | false;
    onClick: (key: string) => void;
  }[];
  /** 選択地域 */
  selectedRegion: string;
  /** 国のリスト */
  countries: {
    id: string;
    text: string;
    select: true | false;
    onClick: (key: string) => void;
  }[];
  /** 選択国 */
  selectedCountry: string;
  /** スマホ表示か否か */
  isMobile?: boolean;
}

/**
 * 国地域選択画面のPresentation Component
 */
export const SelectCountryBoard: React.FC<SelectCountryBoardProps> = ({
  isDisplay,
  glossary,
  onClickClose,
  regions,
  selectedRegion,
  countries,
  selectedCountry,
  isMobile
}) => {
  // Regionsに渡すpropsを生成
  const _regionProps = {
    items: regions,
    selectedLanguage: '',
    selectedPurchase: '',
    selectedRegion,
    selectedCountry
  };
  // Countriesに渡すpropsを生成
  const _countryProps = {
    items: countries,
    selectedLanguage: '',
    selectedPurchase: '',
    selectedRegion,
    selectedCountry
  };

  // PC・タブレット用Component
  const _component = React.useMemo(
    () => (
      <div className="selectArea" data-test="selectCountryBoard-selectArea">
        <Items
          type="region"
          {..._regionProps}
          data-test="selectCountryBoard-Regions"
        />
        <Separator
          type="verticalSeparator"
          data-test="selectCountryBoard-separator-2"
        />
        <Items
          type="country"
          {..._countryProps}
          data-test="selectCountryBoard-countries"
        />
      </div>
    ),
    [_regionProps, _countryProps]
  );

  // スマホ用Component
  const _mobileComponent = React.useMemo(
    () => (
      <>
        <Items
          type="region"
          {..._regionProps}
          data-test="selectCountryBoard-Regions"
        />
        <Separator
          type="separator"
          data-test="selectCountryBoard-separator-2"
        />
        <Items
          type="country"
          {..._countryProps}
          data-test="selectCountryBoard-countries"
        />
      </>
    ),
    [_regionProps, _countryProps]
  );

  return isDisplay ? (
    <div className="selectCountryBoard" data-test="selectCountryBoard">
      <Button
        type="toolButton"
        subType="close"
        data-test={`selectCountryBoard-close-toolButton`}
        onClick={onClickClose}
      />
      <Message type="message" data-test="selectCountryBoard-message">
        {glossary.glx(BoardGL.SelectCountryMessage)}
      </Message>
      <Separator type="separator" data-test="selectCountryBoard-separator-1" />
      {isMobile ? _mobileComponent : _component}
    </div>
  ) : null;
};
